// Copyright (c) 2016 Deere & Company

import './download-to-excel.scss';
import React, {PropTypes} from 'react';

const DownloadToExcel = props =>
    <div className='download-to-excel'>
        <span
            className='excel-icon'
            onClick={props.onDownload}
        />
    </div>;

DownloadToExcel.displayName = 'DownloadToExcel';
DownloadToExcel.propTypes = {
    onDownload: PropTypes.func.isRequired
};

export default DownloadToExcel;



// WEBPACK FOOTER //
// ./src/shared/components/download-to-excel/index.js